import { render, staticRenderFns } from "./ManagerEntrancePackageUpload.vue?vue&type=template&id=a0c0c010&scoped=true"
import script from "./ManagerEntrancePackageUpload.vue?vue&type=script&lang=js"
export * from "./ManagerEntrancePackageUpload.vue?vue&type=script&lang=js"
import style0 from "./ManagerEntrancePackageUpload.vue?vue&type=style&index=0&id=a0c0c010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c0c010",
  null
  
)

export default component.exports